<template>
  <div>
    <div v-show="onProvidersRoute">
      <Grid :providers="providers" />
    </div>

    <v-fade-transition :hide-on-leave="true">
      <router-view :providers="providers" :games="games"></router-view>
    </v-fade-transition>
  </div>
</template>

<script>
import Grid from "./components/grid";

export default {
  props: ["providers", "games"],

  components: { Grid },

  created() {
    this.$nextTick(() => {
      this.$vuetify.goTo(0);
    });
  },

  computed: {
    onProvidersRoute() {
      return this.$route.name === "casinoProviders";
    },
  },
};
</script>

<style></style>
